// frontend/src/services/api.js
import axios from 'axios';

//const API_URL = 'http://localhost:4000';
//const apiUrl = 'http://plaguicidaslmr.senasa.gob.pe'; // Cambia a HTTPS

export const api = axios.create({
  //baseURL: API_URL
  //baseURL: 'http://10.2.0.108:4000', // Asegúrate de que coincide con la IP del backend
 // baseURL: 'http://plaguicidaslmr.senasa.gob.pe:4000', 
  //baseURL: 'https://plaguicidaslmr.senasa.gob.pe/api', 

  baseURL:
  process.env.NODE_ENV === 'production'
    ? '/api'
    : 'http://localhost:4000/api',

  withCredentials: true,
  
});

/*export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
  }); */

// Interceptor para incluir el token en cada petición si existe
api.interceptors.request.use(cfg => {
  const admin = localStorage.getItem('adminToken');
  const client = localStorage.getItem('clientToken');

  /*   Si existe adminToken lo usamos SIEMPRE
       para evitar que un token de cliente
       llegue a los endpoints /admin o /sesiones   */
  const token = admin || client;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

